import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getHistory from '../../../helpers/rounting/getHistory'
import { Alert, Button, Modal, Input, notification, Radio, Typography, Select } from 'antd'
import ErrorList from './errorList'
import queryString from "query-string"
import {
    createBatchByNumberV3,
    listPartner,
    listLevels
} from "../../../services/api/3dApi"

const { TextArea } = Input
const { Text } = Typography
const { Option } = Select

class CreateBatchList extends Component {
    state = {
        isOpen: false,
        loading: false,
        message: '',
        name: [],
        string: '',
        userCreate: '',
        levels: [],
        level: "1",
        error: '',
        partner: '',
        partners: [],
        errorPartner: ''
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isOpen && this.state.isOpen !== prevState.isOpen) {
            const { orders } = this.props
            const listBarcodes = orders.map(i => {
                const { marketplace, item_number } = Object.assign({}, i)
                if (!!marketplace && !!item_number) {
                    return `${marketplace}_${item_number}`
                }
            }).filter(Boolean)

            this.setState(preState => ({
                ...preState,
                string: listBarcodes.join('\n'),
                name: listBarcodes
            }))
            
            this._fetchLevel()
            this._fetchPartner()
        }
    }

    _handleChange = e => {
        const { value } = e.target

        this.setState({
            string: value
        }, () => {
            const arr = this.state.string.split(/#|\r|\n|\t|\r\n|\s|,\s|,/)
            const newArr = arr.filter(item => item !== '')

            this.setState({
                name: newArr
            })
        })
    }

    _handleChangeText = (e) => {
        const { value } = e.target

        this.setState({
            userCreate: value.trim()
        })
    }

    _onChangeRadio = (e) => {
        this.setState({
            level: e.target.value
        })
    }

    _onChangeSelect = (value) => {
        this.setState({
            partner: value
        })
    }

    _handleSubmit = async (e) => {
        e.preventDefault()

        this.setState({
            loading: true
        })

        const { name, userCreate, level, partner } = this.state

        if (name.length === 0) {
            this.setState({
                loading: false,
                message: 'Vui lòng nhập vào một mã order'
            })
        } else {
            try {
                const payload = {
                    templates: name,
                    user_create: userCreate,
                    level: level,
                    partner: partner
                }

                const { data: response } = await createBatchByNumberV3(payload)

                const { success, error, data } = response

                if (!success) {
                    throw new Error(error)
                } else {
                    this.setState({
                        loading: false,
                        isOpen: false
                    })

                    const { errorResult } = data
                    const { _id } = data.batch

                    if (errorResult.length > 0) {
                        notification.error({
                            message: 'ERROR',
                            description: <ErrorList list={errorResult} />,
                            duration: 0,
                        })
                    }

                    if (_id) {
                        const history = getHistory()
                        history.push(`/batches/${_id}`)
                    }
                }
            } catch (error) {
                this.setState({
                    loading: false,
                    message: error.message
                })
            }
        }
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction1' onClick={this._closeModal}
            disabled={this.state.loading}>Hủy</Button>
        const buttonOk = <Button loading={this.state.loading} key='btnOKBulkAction1' type='primary'
            onClick={this._handleSubmit}
            disabled={this.state.loading || !this.state.name.length}>Tạo</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    _openMadal = () => {
        this.setState({
            isOpen: true,
        })
    }

    _fetchPartner = async () => {
        try {
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)

            const { data, success, error } = response

            if (!success) {
                this.setState({
                    errorPartner: error
                })

                return
            }

            this.setState({
                partners: data.partners
            })
        } catch (e) {
            this.setState({
                errorPartner: e.message
            })
        }
    }

    _fetchLevel = async () => {
        try {
            const { data: response } = await listLevels()

            const { data, success, error } = response

            if (!success) {
                this.setState({
                    error: error
                })

                return
            }

            this.setState({
                levels: data
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    render() {
        const {
            isOpen,
            message,
            name,
            string,
            level,
            error,
            levels,
            errorPartner,
            partner,
            partners,
        } = this.state

        const modalFooter = this._renderModalFooter()

        return (
            <>
                <span onClick={this._openMadal}>Tạo lô</span>
                <Modal
                    visible={isOpen}
                    title='Tạo Lô'
                    className='GenerateTemplateByQuery'
                    onCancel={this._closeModal}
                    closable={false}
                    footer={modalFooter}
                >
                    {
                        message && <Alert className="mb-3" message="Lỗi" description={message} type="error" />
                    }
                    <div>
                        <div className="mb-2">
                            <label htmlFor='listTemplateIds' className='fs-16'>
                                Nhập templates theo từng dòng hoặc cách nhau bằng dấu phẩy:
                            </label>
                            <TextArea rows={6} onChange={this._handleChange} placeholder='123456_7'
                                value={string}>{string}</TextArea>
                        </div>

                        <div className='mt-2'>
                            Đã nhập: <span className='font-weight-bold'>{name.length} items</span>
                        </div>

                        <label className="font-weight-bold mt-3">Người tạo:</label>
                        <Input 
                            type="text" 
                            placeholder="Nhập tên người tạo"
                            onChange={this._handleChangeText}
                        />

                        <label className='d-block mt-3 font-weight-bold'>Đối tác in/ép:</label>
                        {
                            errorPartner ?
                                <Text type='danger'>{errorPartner}</Text> :
                                <Select 
                                    dropdownClassName='custom-select-partner'
                                    onChange={this._onChangeSelect} 
                                    value={partner} 
                                    className='customSelect'
                                >
                                    <Option value={''}>---Hãy chọn 1 đối tác---</Option>
                                    {
                                        partners.length > 0 && partners.map(item => <Option key={item._id} value={item._id}>{item.name}</Option>)
                                    }
                                </Select>
                        }

                        <label className='mt-3 d-block font-weight-bold'>
                            Độ ưu tiên:
                        </label>
                        {
                            error ?
                                <Text type='danger'>{error}</Text> :
                                <Radio.Group onChange={this._onChangeRadio} value={level}>
                                    {
                                        levels.length > 0 && levels.map(item => (
                                            <Radio key={item.key} value={item.key}>{item.value}</Radio>
                                        ))
                                    }
                                </Radio.Group>
                        }
                    </div>
                </Modal>
            </>
        )
    }
}

CreateBatchList.propTypes = {
    onResetAction: PropTypes.func.isRequired,
    query: PropTypes.object.isRequired
}

export default CreateBatchList
